import AutomationError from './AutomationError';
class NothingToRelase extends AutomationError {
    constructor(options) {
        super('The investor does not have rent income available to release.', options);
    }
}
export default NothingToRelase;
